module.exports = __webpack_public_path__ + "static-portal/img/61-1.0d40cb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yingyong/61-1.jpg
// module id = 1opf
// module chunks = 4